import React from 'react';

import { UiKit } from 'components';
import { useExchangesConfig } from '../context';

/**
 * @param {object} props
 * @param {(err: Error, data: any) => void} props.onDone
 * @param {React.ReactNode} props.children
 */
export default function SaveButton({
  onDone = () => {},
  children = 'Continue'
}) {
  const { isDirty, isProcessing, onSave } = useExchangesConfig();

  const onClick = () => {
    if (!isDirty) return onDone();
    onSave(onDone);
  };

  return (
    <UiKit.Button
      size="lg"
      onClick={onClick}
      disabled={isProcessing}
      processing={isProcessing}
    >
      {children}
    </UiKit.Button>
  );
}
